import "./leftBar.scss";
import Targets from "../../assets/targets.png";
import Cases from "../../assets/cases.png";
import Market from "../../assets/3.png";
import Watch from "../../assets/4.png";
import Timeline from "../../assets/timeline.png";
import Events from "../../assets/6.png";
import Gaming from "../../assets/7.png";
import Gallery from "../../assets/8.png";
import Videos from "../../assets/9.png";
import Messages from "../../assets/10.png";
import Tutorials from "../../assets/11.png";
import Courses from "../../assets/12.png";
import Fund from "../../assets/13.png";
import Scheduler from "../../assets/scheduler_alt1.png";
import { AuthContext } from "../../context/authContext";
import { useContext } from "react";
import { Link } from "react-router-dom";

const LeftBar = () => {

  const { currentUser } = useContext(AuthContext);

  return (
    <div className="leftBar">
      <div className="container">
        <div className="menu">
          <div className="user">
            <Link to={`/profile/${currentUser.id}`}> 
            <img
              src={currentUser.profilePic}
              alt=""
            />
            <span>{currentUser.name}</span>
            </Link>
          </div>
          <div className="item">
            <Link to="/targets">
              <img src={Targets} alt="" />
              <span>Targets</span>
            </Link>
          </div>
          <div className="item">
            <Link to="/cases">
              <img src={Cases} alt="" />
              <span>Cases</span>
            </Link>
          </div>
          <div className="item">
            <Link to="/geolocation">
              <img src={Market} alt="" />
              <span>Geolocation</span>
            </Link>
          </div>
          <div className="item">
          <Link to="/events">
              <img src={Timeline} alt="" />
              <span>Timeline</span>
            </Link>
          </div>
          <div className="item">
              <Link to="/schedules">
              <img src={Scheduler} alt="" />
              <span>Schedules</span>
            </Link>
          </div>
        </div>
        <hr />
{/*         
        <div className="menu">
          <span>Your shortcuts</span>
          <div className="item">
            <img src={Watch} alt="" />
            <span>Watch</span>
          </div>
          
          <div className="item">
            <img src={Gaming} alt="" />
            <span>Gaming</span>
          </div>
          <div className="item">
            <img src={Gallery} alt="" />
            <span>Gallery</span>
          </div>
          <div className="item">
            <img src={Videos} alt="" />
            <span>Videos</span>
          </div>
          <div className="item">
            <img src={Messages} alt="" />
            <span>Messages</span>
          </div>
        </div>
        <hr />
        <div className="menu">
          <span>Others</span>
          <div className="item">
            <img src={Fund} alt="" />
            <span>Fundraiser</span>
          </div>
          <div className="item">
            <img src={Tutorials} alt="" />
            <span>Tutorials</span>
          </div>
          <div className="item">
            <img src={Courses} alt="" />
            <span>Courses</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LeftBar;
